<template>
  <div class="finalcial-support-card">
    <el-card class="card support-box" shadow="hover" >
      <template #header>
            <i class="el-icon-s-finance el-card-header-icon" />
            <span class="el-card-header-txt">打赏信息</span>
        </template>
      <p class="tip-1">创作不易, 感谢支持!</p>
      <img class="img-receiving-qrcode" :src="wechatReceivingQrcode" alt="微信收款码" />
      <!-- <img class="img-receiving-qrcode" :src="alipayReceivingQrcode" alt="支付宝收款码" /> -->
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import wechatReceivingQrcode from '@/assets/wechatReceivingQrcode.png'
import alipayReceivingQrcode from '@/assets/alipayReceivingQrcode.jpg'

export default defineComponent({
  setup() {
    return {
      wechatReceivingQrcode,
      alipayReceivingQrcode,
    }
  },
})
</script>

<style lang="scss" scoped>
.finalcial-support-card {
  margin-top: 20px;
  .support-box {
    .img-receiving-qrcode {
      width: 100%;
      height: 226.66px;
    }
  }
}
</style>